// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"2931bf0c","180":"39df81b2","208":"c4d5c46d","631":"b229a922","774":"2f20bbab","787":"95b0c1cd","820":"5ce26067","910":"bdb76339"}[chunkId] + ".chunk.js";
};